import type { RequestError } from '@ps/web-core-api';
import type { SingleAvailableOpportunity } from '@ps/web-sports-api-types';
import type { BettableOpportunities } from '@ps/web-sports-types';

import { errorView } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { createMultipleEntities } from './createMultipleEntities';
import { createSingleEntities } from './createSingleEntities';
import { mergeWithTrackingContextValue } from './utils/mergeWithTrackingContextValue';

interface BetPlacedExceptionProps {
  exception: RequestError;
  bettableOpportunities: BettableOpportunities;
  opportunities: SingleAvailableOpportunity[];
}

export const betPlacementException = (
  context: TrackingContextValue,
  { exception, bettableOpportunities, opportunities }: BetPlacedExceptionProps
) => {
  context = mergeWithTrackingContextValue(context, [
    ...createSingleEntities(bettableOpportunities.SINGLE),
    ...createMultipleEntities(opportunities)(bettableOpportunities.MULTIPLE)
  ]);

  try {
    const parsedException = JSON.parse(exception.body.code) as {
      faultstring: string;
      detail: { message: string };
    };

    GAEvent(
      { action: `(${parsedException.faultstring}) ${parsedException.detail.message}` },
      context
    );

    errorView(
      { errorCode: `(${parsedException.faultstring}) ${parsedException.detail.message}` },
      context
    );
  } catch (e) {
    GAEvent({ action: 'Bet placement failed' }, context);
    errorView({ errorCode: 'Bet placement failed' }, context);
  }
};
